import { defineComponent as B, useAttrs as b, computed as o, reactive as z, provide as R, openBlock as V, createElementBlock as _, normalizeClass as g, unref as h, renderSlot as y } from "vue";
import { RadioSize as C, RadioGroupDirection as a, RadioSymbol as S } from "./novoui-vuejs59.js";
import { ERadioBorderVariants as x } from "./novoui-vuejs55.js";
const A = /* @__PURE__ */ B({
  __name: "NRadioGroup",
  props: {
    name: {},
    modelValue: { type: [String, Number, Boolean] },
    disabled: { type: Boolean },
    error: { type: Boolean },
    size: { default: C.medium },
    direction: { default: a.column },
    variant: { default: x.fill }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: n }) {
    const e = r, i = n, l = (t) => {
      i("update:modelValue", t);
    }, s = b(), d = o(() => e.size), c = o(() => e.error), m = o(() => s.name), u = o(() => e.disabled), p = o(() => e.modelValue), f = o(() => e.variant), v = z({
      size: d,
      name: m,
      disabled: u,
      error: c,
      onChange: l,
      selected: p,
      variant: f
    });
    return R(S, v), (t, k) => (V(), _("div", {
      class: g([
        "flex ",
        {
          "flex-col ": e.direction === h(a).column
        }
      ])
    }, [
      y(t.$slots, "default")
    ], 2));
  }
});
export {
  A as default
};
